export { AmpAccordion } from './Accordion/AmpAccordion'
export { AmpLayout } from './Layout/AmpLayout'
export { AmpSidebar } from './Sidebar/AmpSidebar'
export { AmpImage } from './Image/AmpImage'
export { AmpCarousel } from './Carousel/AmpCarousel'
export { AmpTwitter } from './Twitter/AmpTwitter'
export { AmpFacebook } from './Facebook/AmpFacebook'
export { AmpYoutube } from './Youtube/AmpYoutube'
export { AmpInstagram } from './Instagram/AmpInstagram'
export { AmpPinterest } from './Pinterest/AmpPinterest'

export type AmpLayoutType =
  | 'fill'
  | 'fixed'
  | 'fixed-height'
  | 'flex-item'
  | 'intrinsic'
  | 'nodisplay'
  | 'responsive'

export interface AmpImgType {
  alt?: string
  src?: string
  width?: number
  height?: number
  layout?: AmpLayoutType
}
